<template>
  <div class="mobile_banner">
    <div class="swiper-container" id="mobile_swiperIndex">
      <div class="swiper-wrapper">
        <div
          v-for="(item, i) in sliders"
          :key="i"
          class="swiper-slide slider_img"
        >
          <img :src="item.img" />
          <div class="mobile_banner_mask" >
            <p @click="go()" v-if="i== 0" class="mobile_banner_mask_title" style="width: 5rem;top: 7rem;">鼎函科技</p>
            <p v-if="i== 0" class="mobile_banner_mask_desc" style="left: 2rem;">DINGHAN TECHNOLOGY</p>
            <p v-if="i!= 0" class="mobile_banner_mask_title">{{ item.title }}</p>
            <p v-if="i!= 0" class="mobile_banner_mask_desc">{{ item.desc }}</p>
           
          </div>
        </div>
      </div>
      <!-- //换页器 -->
      <div class="swiper-pagination"></div>
      <!-- //前进后退 -->
      <!-- <div class="swiper-button-next swiper-button-white"></div>
      <div class="swiper-button-prev swiper-button-white"></div> -->
      <!-- //滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import Swiper from "swiper";
var mobileSwiper;
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      sliders: [
        {
          img: require("../../../static/mobile/banner_1.jpg"),
          title: "",
          desc: "",
        },
        {
          img: require("../../../static/mobile/banner_6.jpg"),
          title: "创新模式",
          desc: "三合一担保体系",
        },
        {
          img: require("../../../static/mobile/banner_3.jpg"),
          title: "安全保密",
          desc: "全程电子留痕可追溯",
        },
        {
          img: require("../../../static/mobile/banner_4.jpg"),
          title: "企业减负",
          desc: "节省投标时间成本",
        },
        {
          img: require("../../../static/mobile/banner_5.jpg"),
          title: "方便快捷",
          desc: "分钟级别快速出函",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    new this.$wow.WOW().init();
    mobileSwiper = new Swiper("#mobile_swiperIndex", {
      //配置分页器内容

      loop: true, // 循环模式选项
      pagination: {
        el: ".swiper-pagination", //换页器与哪个标签关联
        clickable: true, //分页器是否可以点击
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      allowTouchMove: true,
      autoplay: true,
      delay: 200,
      speed: 1000,
      effect: "slide",
    });
    mobileSwiper.navigation.$nextEl.css("display", "none");
    mobileSwiper.navigation.$prevEl.css("display", "none");
  },
  methods: {
  
  },
};
</script>

<style scoped >
.slider_img {
  width: 100%;
  height: 41.5625rem;
}
.slider_img img{
  width: 100%;
  height: 41.5625rem;

}
.mobile_banner_mask{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.25);

}
.mobile_banner_mask_title{
    font-size: 2rem;
    position: absolute;
    top: 9rem;
    left: 2rem;
    font-weight: 700;
}
.mobile_banner_mask_desc{
    font-size: 1.4rem;
    position: absolute;
    top: 17rem;
    left: 7rem;
    /* font-weight: 700; */
    letter-spacing:0.1rem
}
.swiper-pagination{
    bottom: 15rem;
}
</style>
